import styled from 'styled-components';

export const Component = styled.span`
  position: absolute;
  top: 50%;
  left: var(--value, 0);
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;

  user-select: none;
  pointer-events: none;
`;
